// avoid import loops by keeping this file free of imports
export const ELEMENT_SECTION = "section";
